import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  *,
  *:after,
  *:before {
    box-sizing: border-box;
  }

  /* Normalize.css: Add the correct display in IE 10 */
  [hidden] {
    display: none;
  }

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    cursor: pointer;
    font-family: inherit;
    line-height: inherit;
    transition: background-color 0.2s ease-in-out;
  }

  /* Normalize.css: Remove the border on images inside links in IE 10 */
  img {
    border-style: none;
  }

  html, body {
    border: 0;
    color: #303030;
    height: 100%;
    font: inherit;
    font-size: 100%;
    font-weight: 400;
    /* Normalize.css: Correct the line height in all browsers */
    line-height: 1.15;
    margin: 0;
    padding: 0;
    /* Normalize.css: Prevent adjustments of font size after orientation changes in iOS */
    -webkit-text-size-adjust: 100%;
  }

  body {
    font-family: Montserrat;
    line-height: 1;
  }

  button,
  button:active,
  button:focus {
    outline: none;
  }
`;
